
import * as React from 'react';
import { Link } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { Pagination } from '../core/Pagination';
import { CMS } from '../shared/index';
import { getAjaxhelper } from '../utils/CoreAjaxHelper';
import { CoreComponentAjaxUtils, momentWrapper } from '../utils/index';
export interface NewsProps extends BaseComponentProps {
    lang: string;
    history?: History;
}

export interface NewsState extends BaseComponentState {
    datas: CMS.CmsBlog[];
    page: number;
    count: number;
    pageSize: number;
}

export class News extends BaseComponent<NewsProps, NewsState> {

    constructor(props: NewsProps) {
        super(props);
        this.state = {
            datas: [], page: 0, count: 0, pageSize: 5
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData: () => any = () => {
        new CoreComponentAjaxUtils(getAjaxhelper()).getPagedDataWithPromise({
            modelName: 'CmsBlog',
            pageSize: this.state.pageSize,
            page: this.state.page,
            orders: [['createdAt', 'desc']]
        }).then(
            d => {
                // console.log("News", d);
                this.setStateHelper(st => {
                    st.datas = d.rows!;
                    st.count = d.count!;
                });
            }).catch((exc) => { console.error('error: ', exc); });
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let page = [];
        for (let a of this.state.datas) {
            let img = <img className='col-md-4' src={`/uploads/blog/thumb/${a.thumbUrl}`} />;
            if (a.thumbUrl!.substring(0, 4) === 'http') {
                img = <img className='col-md-4' alt="" src={`${a.thumbUrl}`}   />;
            }
            page.push(
                <div className='row' style={{ paddingBottom: 15, }}>
                    {img}
                    <div className='col-md-8' style={{ minHeight: 200, position: 'relative' }}>
                        <h3>{a.name}</h3>
                        <p>{a.shortDescription}</p>
                        <div style={{ position: 'absolute', padding: 10, bottom: '0', background: 'rgba(238, 238, 238, 0.54)', width: 'calc( 100% - 30px)' }}>
                            {momentWrapper(a["createdAt"]).format('MMMM Do YYYY')}
                            <Link className='right' to={`/${a.slug}`}> [ Read More ]  </Link>
                        </div>
                    </div>

                </div>
            );
        }
        return (
            <div>
                {page}
                <Pagination
                    key='pagination'
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    totalCount={this.state.count}
                    onChangePage={this.onChangePage}
                />
            </div>
        );
    }
    onChangePage: (page: number) => any = (page: number) => {
        this.setStateHelper(st => st.page = page, () => {
            this.getData();
        });
    }
}



// WEBPACK FOOTER //
// ./src/static-content/News.tsx